<template>
  <div>
    <nav-common :nav="nav"></nav-common>
    <div class="center-intro">
      <div class="center-intro-content">
        <div class="list">
          <list-item
            v-for="item in coorList"
            :key="'coor'+item.id"
            :itemData="item"
            @toPage="getDetail"
          ></list-item>
        </div>
      </div>
    </div>
    <div>
      <model-page :dataObj="ariList" @nextPage="nextPage"></model-page>
    </div>
  </div>
</template>
<style scoped>
.center-intro {
  width: 100%;
  background: #e6ecf2;
  border: 1px solid #e6ecf2;
  box-sizing: border-box;
  border-radius: 10px 10px 0 0;
  padding: 20px 0 0 0;
  box-sizing: border-box;
}
.center-intro-content {
  width: 100%;
  background: #fff;
  color: #222;
  padding: 0 40px;
  box-sizing: border-box;
}
</style>

<script>
import navCommon from "@/components/views/common/nav.vue";
import listItem from "@/components/views/common/listItem.vue";
import ModelPage from "@/components/views/common/ModelPage";
import { userApi } from "@/api/user.js";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      nav: {
        firsttitle: "科研与国际合作",
        firstrouteName: "CooperMajor",
        secondtitle: "",
        secondrouteName: "",
        thirdtitle: "",
        thirdrouteName: ""
      },
      search_word: "",
      ariList: [], //分页所需的值
      coorList: [],
      page: 1,
      count: 10
    };
  },
  computed: {
    ...mapGetters(["searchVuex"])
  },
  methods: {
    ...mapActions(["setSearch"]),
    getCoorList() {
      const params = {
        type: this.$route.query.type,
        page: this.page,
        count: this.count,
         search_word: this.search_word
      };
      userApi.cooperationList(params).then(res => {
        this.ariList = res.data;
        this.coorList = res.data.list;
        if (this.ariList.total == "1") {
          this.$router.push({
            name: "CooperDetail",
            query: {
              showFlag: this.$route.query.showFlag,
              type: this.$route.query.type,
              id: this.coorList[0].id
            }
          });
        }
      });
    },
    nextPage(pageNo) {
      this.page = pageNo;
      this.getCoorList();
    },
    getDetail(id) {
      this.$router.push({
        name: "CooperDetail",
        query: {
          showFlag: this.$route.query.showFlag,
          type: this.$route.query.type,
          id: id
        }
      });
    },
    handleRoute() {
      this.count = 10;
      this.page = 1;
      var arr = [
        "重大专项",
        "国际合作",
        "管理规定",
        "科研项目介绍",
        "获奖项目清单",
        "常用文件下载"
      ];
      this.nav.secondtitle = arr[this.$route.query.type * 1 - 1];
    }
  },
  watch: {
    $route() {
      this.handleRoute();
      this.getCoorList();
    },
        searchVuex(newArr, oldArr) {
      this.search_word = newArr;
      if (this.search_word == "") {
        this.getCoorList();
      }
      this.getCoorList();
    }
  },
  mounted() {
    this.handleRoute();
    this.getCoorList();
  },
  components: {
    navCommon,
    listItem,
    ModelPage
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/Cooperation/Children/major.vue